import * as vp from 'vopay';
import { Box, SubTitle, Table, Card } from 'vopay';
import { Button } from 'UI';
import { FunctionComponent } from 'react';
import { usePartnerData } from '@/providers/PartnerData.provider';

type AccountUserType = {
  Username: string;
  'Date Added'?: string;
  UserType: string;
};

type UsersListProps = {
  accounts: AccountUserType[];
  handlers: {
    onAddUserPage: () => void;
    onChangePasswordPage: (values: vp.AccountUsersChangePasswordRequest) => void;
    onDeleteUser: (values: vp.DeleteAccountUserRequest) => void;
    onAccountUserPermissionPage: (values: vp.AccountUserPermissionsRequest) => void;
  };
};

type FC = FunctionComponent<UsersListProps>;

const Users: FC = (props: UsersListProps) => {
  const { handlers, accounts } = props;
  const {
    response: { isRoleViewOnly },
  } = usePartnerData();

  const tableProps: vp.TableProps<AccountUserType> = {
    id: 'user-account-list-table',
    version: '2',
    zebra: true,
    columns: [
      {
        id: 'Username',
        header: 'Email Address',
        align: 'left',
        field: 'Username',
      },
      {
        id: 'DateAdded',
        header: 'Date Added',
        align: 'left',
        field: 'Date Added',
      },
      {
        id: 'view',
        header: 'Actions',
        align: 'right',
        template: ({ data }) => {
          return (
            <Box jc="fe" gap="sm">
              <Button
                id={`user-change-Permissions-${data.Username}`}
                onClick={() => {
                  handlers.onAccountUserPermissionPage({ EmailAddress: data.Username });
                }}
                size="small"
                disabled={isRoleViewOnly}
              >
                Permissions
              </Button>
              <Button
                id={`user-change-${data.Username}`}
                onClick={() => {
                  handlers.onChangePasswordPage({
                    EmailAddress: data.Username,
                    NewPassword: '',
                    SendEmail: true,
                  });
                }}
                size="small"
                disabled={isRoleViewOnly}
              >
                Change Password
              </Button>
              <Button
                id={`user-delete-${data.Username}`}
                onClick={() => {
                  handlers.onDeleteUser({ EmailAddress: data.Username });
                }}
                size="small"
                disabled={isRoleViewOnly}
              >
                Remove
              </Button>
            </Box>
          );
        },
      },
    ],
    rows: accounts.map((user) => ({
      id: String(user.Username),
      data: user,
    })),
  };

  return (
    <Box flx="col" gapSize="36px">
      <Box mt="lg" jc="sb" ai="center">
        <SubTitle subTitle="VoPay Account Portal Users" />
        <Button
          id="showHideAccountCredentials"
          onClick={handlers.onAddUserPage}
          colorScheme="primary"
          disabled={isRoleViewOnly}
        >
          Add User
        </Button>
      </Box>
      <Card style={{ padding: '16px' }}>
        <Table {...tableProps} />
      </Card>
    </Box>
  );
};

export default Users;
